module.exports = function() {
  return new Worker(__webpack_public_path__ + "97b70f7d4be63da9798f.worker.js");
};